import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../constants/Endpoints';
import { Cacheable, CacheBuster } from 'ts-cacheable';
import { Observable, Subject, tap } from 'rxjs';

export const cacheBuster$ = new Subject<void>();
@Injectable({ providedIn: 'root' })
export class BackofficeFeedbackService {
  private http = inject(HttpClient);

  unreadCount = signal<number>(0);

  @Cacheable({
    cacheBusterObserver: cacheBuster$,
    maxAge: 24 * 60 * 60 * 1000,
  }) // cache for 24h
  loadUnreadCount(): Observable<{ count: number }> {
    return this.http
      .get<{ count: number }>(endpoints.getUnreadFeedbackCount.url)
      .pipe(tap((r) => this.unreadCount.set(r.count)));
  }

  @CacheBuster({ cacheBusterNotifier: cacheBuster$ })
  toggleReadStatus(id: number, isRead: boolean): Observable<any> {
    const url = endpoints.feedbackMarkRead.url.replace('{id}', String(id));
    return this.http.post<any>(url, { is_read: isRead ? 1 : 0 });
  }
}
